// ─── ACTION TYPES ─────────────────────────────────────────────────────────────

export const HELIX_CRQS_ACTIONS = {

	// ── Creations: Get CRQs to Create ─────────────────────────────────────────
	HC_GET_CRQS_TO_CREATE_REQUEST: 'HC_GET_CRQS_TO_CREATE_REQUEST',
	HC_GET_CRQS_TO_CREATE_SUCCESS: 'HC_GET_CRQS_TO_CREATE_SUCCESS',
	HC_GET_CRQS_TO_CREATE_FAILURE: 'HC_GET_CRQS_TO_CREATE_FAILURE',

	// ── Creations: Get CRQs on Queue with Error ───────────────────────────────
	HC_GET_CRQS_ON_QUEUE_WITH_ERROR_REQUEST: 'HC_GET_CRQS_ON_QUEUE_WITH_ERROR_REQUEST',
	HC_GET_CRQS_ON_QUEUE_WITH_ERROR_SUCCESS: 'HC_GET_CRQS_ON_QUEUE_WITH_ERROR_SUCCESS',
	HC_GET_CRQS_ON_QUEUE_WITH_ERROR_FAILURE: 'HC_GET_CRQS_ON_QUEUE_WITH_ERROR_FAILURE',

	// ── Creations: CRQs to Create Action ──────────────────────────────────────
	HC_CRQS_TO_CREATE_ACTION_REQUEST: 'HC_CRQS_TO_CREATE_ACTION_REQUEST',
	HC_CRQS_TO_CREATE_ACTION_SUCCESS: 'HC_CRQS_TO_CREATE_ACTION_SUCCESS',
	HC_CRQS_TO_CREATE_ACTION_FAILURE: 'HC_CRQS_TO_CREATE_ACTION_FAILURE',

	// ── Creations: CRQs on Queue with Error Action ────────────────────────────
	HC_CRQS_ON_QUEUE_WITH_ERROR_ACTION_REQUEST: 'HC_CRQS_ON_QUEUE_WITH_ERROR_ACTION_REQUEST',
	HC_CRQS_ON_QUEUE_WITH_ERROR_ACTION_SUCCESS: 'HC_CRQS_ON_QUEUE_WITH_ERROR_ACTION_SUCCESS',
	HC_CRQS_ON_QUEUE_WITH_ERROR_ACTION_FAILURE: 'HC_CRQS_ON_QUEUE_WITH_ERROR_ACTION_FAILURE',

	// ── Changes: Get CRQs to Close ────────────────────────────────────────────
	HC_GET_CRQS_TO_CLOSE_REQUEST: 'HC_GET_CRQS_TO_CLOSE_REQUEST',
	HC_GET_CRQS_TO_CLOSE_SUCCESS: 'HC_GET_CRQS_TO_CLOSE_SUCCESS',
	HC_GET_CRQS_TO_CLOSE_FAILURE: 'HC_GET_CRQS_TO_CLOSE_FAILURE',

	// ── Changes: Get CRQs to Cancel ───────────────────────────────────────────
	HC_GET_CRQS_TO_CANCEL_REQUEST: 'HC_GET_CRQS_TO_CANCEL_REQUEST',
	HC_GET_CRQS_TO_CANCEL_SUCCESS: 'HC_GET_CRQS_TO_CANCEL_SUCCESS',
	HC_GET_CRQS_TO_CANCEL_FAILURE: 'HC_GET_CRQS_TO_CANCEL_FAILURE',

	// ── Changes: Get CRQs to Approve ─────────────────────────────────────────
	HC_GET_CRQS_TO_APPROVE_REQUEST: 'HC_GET_CRQS_TO_APPROVE_REQUEST',
	HC_GET_CRQS_TO_APPROVE_SUCCESS: 'HC_GET_CRQS_TO_APPROVE_SUCCESS',
	HC_GET_CRQS_TO_APPROVE_FAILURE: 'HC_GET_CRQS_TO_APPROVE_FAILURE',

	// ── Changes: Action ───────────────────────────────────────────────────────
	HC_CRQS_TO_CHANGE_ACTION_REQUEST: 'HC_CRQS_TO_CHANGE_ACTION_REQUEST',
	HC_CRQS_TO_CHANGE_ACTION_SUCCESS: 'HC_CRQS_TO_CHANGE_ACTION_SUCCESS',
	HC_CRQS_TO_CHANGE_ACTION_FAILURE: 'HC_CRQS_TO_CHANGE_ACTION_FAILURE',

	// ── Other: Get CRQs with Conflicts ────────────────────────────────────────
	HC_GET_CRQS_WITH_CONFLICTS_REQUEST: 'HC_GET_CRQS_WITH_CONFLICTS_REQUEST',
	HC_GET_CRQS_WITH_CONFLICTS_SUCCESS: 'HC_GET_CRQS_WITH_CONFLICTS_SUCCESS',
	HC_GET_CRQS_WITH_CONFLICTS_FAILURE: 'HC_GET_CRQS_WITH_CONFLICTS_FAILURE',

	// ── Other: Get CRQs to Add Activity ──────────────────────────────────────
	HC_GET_CRQS_TO_ADD_ACTIVITY_REQUEST: 'HC_GET_CRQS_TO_ADD_ACTIVITY_REQUEST',
	HC_GET_CRQS_TO_ADD_ACTIVITY_SUCCESS: 'HC_GET_CRQS_TO_ADD_ACTIVITY_SUCCESS',
	HC_GET_CRQS_TO_ADD_ACTIVITY_FAILURE: 'HC_GET_CRQS_TO_ADD_ACTIVITY_FAILURE',

	// ── Other: CRQs with Conflicts Action ────────────────────────────────────
	HC_CRQS_WITH_CONFLICTS_ACTION_REQUEST: 'HC_CRQS_WITH_CONFLICTS_ACTION_REQUEST',
	HC_CRQS_WITH_CONFLICTS_ACTION_SUCCESS: 'HC_CRQS_WITH_CONFLICTS_ACTION_SUCCESS',
	HC_CRQS_WITH_CONFLICTS_ACTION_FAILURE: 'HC_CRQS_WITH_CONFLICTS_ACTION_FAILURE',

	// ── Other: CRQs to Add Activity Action ───────────────────────────────────
	HC_CRQS_TO_ADD_ACTIVITY_ACTION_REQUEST: 'HC_CRQS_TO_ADD_ACTIVITY_ACTION_REQUEST',
	HC_CRQS_TO_ADD_ACTIVITY_ACTION_SUCCESS: 'HC_CRQS_TO_ADD_ACTIVITY_ACTION_SUCCESS',
	HC_CRQS_TO_ADD_ACTIVITY_ACTION_FAILURE: 'HC_CRQS_TO_ADD_ACTIVITY_ACTION_FAILURE',

	// ── Upload: Get Bot Summary ────────────────────────────────────────────────
	HC_GET_BOT_SUMMARY_REQUEST: 'HC_GET_BOT_SUMMARY_REQUEST',
	HC_GET_BOT_SUMMARY_SUCCESS: 'HC_GET_BOT_SUMMARY_SUCCESS',
	HC_GET_BOT_SUMMARY_FAILURE: 'HC_GET_BOT_SUMMARY_FAILURE',

	// ── Creations: Download Template ─────────────────────────────────────────
	HC_DOWNLOAD_TEMPLATE_REQUEST: 'HC_DOWNLOAD_TEMPLATE_REQUEST',
	HC_DOWNLOAD_TEMPLATE_SUCCESS: 'HC_DOWNLOAD_TEMPLATE_SUCCESS',
	HC_DOWNLOAD_TEMPLATE_FAILURE: 'HC_DOWNLOAD_TEMPLATE_FAILURE',

	// ── Change: Download Template ─────────────────────────────────────────────
	HC_DOWNLOAD_CHANGES_TEMPLATE_REQUEST: 'HC_DOWNLOAD_CHANGES_TEMPLATE_REQUEST',
	HC_DOWNLOAD_CHANGES_TEMPLATE_SUCCESS: 'HC_DOWNLOAD_CHANGES_TEMPLATE_SUCCESS',
	HC_DOWNLOAD_CHANGES_TEMPLATE_FAILURE: 'HC_DOWNLOAD_CHANGES_TEMPLATE_FAILURE',

	// ── Add Activity: Download Template ───────────────────────────────────────
	HC_DOWNLOAD_ADD_ACTIVITY_TEMPLATE_REQUEST: 'HC_DOWNLOAD_ADD_ACTIVITY_TEMPLATE_REQUEST',
	HC_DOWNLOAD_ADD_ACTIVITY_TEMPLATE_SUCCESS: 'HC_DOWNLOAD_ADD_ACTIVITY_TEMPLATE_SUCCESS',
	HC_DOWNLOAD_ADD_ACTIVITY_TEMPLATE_FAILURE: 'HC_DOWNLOAD_ADD_ACTIVITY_TEMPLATE_FAILURE',

	// ── Statistics: Get Statistics ────────────────────────────────────────────────
	HC_GET_STATISTICS_REQUEST: 'HC_GET_STATISTICS_REQUEST',
	HC_GET_STATISTICS_SUCCESS: 'HC_GET_STATISTICS_SUCCESS',
	HC_GET_STATISTICS_FAILURE: 'HC_GET_STATISTICS_FAILURE',

	// ── Creations: Export CRQs to Create ──────────────────────────────────────
	HC_EXPORT_CRQS_CREATIONS_REQUEST: 'HC_EXPORT_CRQS_CREATIONS_REQUEST',
	HC_EXPORT_CRQS_CREATIONS_SUCCESS: 'HC_EXPORT_CRQS_CREATIONS_SUCCESS',
	HC_EXPORT_CRQS_CREATIONS_FAILURE: 'HC_EXPORT_CRQS_CREATIONS_FAILURE',

	// ── Changes: Export CRQs Changes ──────────────────────────────────────────
	HC_EXPORT_CRQS_CHANGES_REQUEST: 'HC_EXPORT_CRQS_CHANGES_REQUEST',
	HC_EXPORT_CRQS_CHANGES_SUCCESS: 'HC_EXPORT_CRQS_CHANGES_SUCCESS',
	HC_EXPORT_CRQS_CHANGES_FAILURE: 'HC_EXPORT_CRQS_CHANGES_FAILURE',

	// ── Other: Export CRQs Other ──────────────────────────────────────────────
	HC_EXPORT_CRQS_OTHER_REQUEST: 'HC_EXPORT_CRQS_OTHER_REQUEST',
	HC_EXPORT_CRQS_OTHER_SUCCESS: 'HC_EXPORT_CRQS_OTHER_SUCCESS',
	HC_EXPORT_CRQS_OTHER_FAILURE: 'HC_EXPORT_CRQS_OTHER_FAILURE',

	// ── Statistics: Export ────────────────────────────────────────────────────
	HC_EXPORT_CRQS_STATISTICS_REQUEST: 'HC_EXPORT_CRQS_STATISTICS_REQUEST',
	HC_EXPORT_CRQS_STATISTICS_SUCCESS: 'HC_EXPORT_CRQS_STATISTICS_SUCCESS',
	HC_EXPORT_CRQS_STATISTICS_FAILURE: 'HC_EXPORT_CRQS_STATISTICS_FAILURE',

};

// ─── ACTION CREATORS ──────────────────────────────────────────────────────────

// Creations: Get CRQs to Create
export const hcGetCrqsToCreateRequest = ()        => ({ type: HELIX_CRQS_ACTIONS.HC_GET_CRQS_TO_CREATE_REQUEST });
export const hcGetCrqsToCreateSuccess = (payload) => ({ type: HELIX_CRQS_ACTIONS.HC_GET_CRQS_TO_CREATE_SUCCESS, payload });
export const hcGetCrqsToCreateFailure = (error)   => ({ type: HELIX_CRQS_ACTIONS.HC_GET_CRQS_TO_CREATE_FAILURE, error });

// Creations: Get CRQs on Queue with Error
export const hcGetCrqsOnQueueWithErrorRequest = ()        => ({ type: HELIX_CRQS_ACTIONS.HC_GET_CRQS_ON_QUEUE_WITH_ERROR_REQUEST });
export const hcGetCrqsOnQueueWithErrorSuccess = (payload) => ({ type: HELIX_CRQS_ACTIONS.HC_GET_CRQS_ON_QUEUE_WITH_ERROR_SUCCESS, payload });
export const hcGetCrqsOnQueueWithErrorFailure = (error)   => ({ type: HELIX_CRQS_ACTIONS.HC_GET_CRQS_ON_QUEUE_WITH_ERROR_FAILURE, error });

// Creations: CRQs to Create Action
export const hcCrqsToCreateRequest = ()        => ({ type: HELIX_CRQS_ACTIONS.HC_CRQS_TO_CREATE_ACTION_REQUEST });
export const hcCrqsToCreateSuccess = (payload) => ({ type: HELIX_CRQS_ACTIONS.HC_CRQS_TO_CREATE_ACTION_SUCCESS, payload });
export const hcCrqsToCreateFailure = (error)   => ({ type: HELIX_CRQS_ACTIONS.HC_CRQS_TO_CREATE_ACTION_FAILURE, error });

// Creations: CRQs on Queue with Error Action
export const hcCrqsOnQueueWithErrorRequest = ()        => ({ type: HELIX_CRQS_ACTIONS.HC_CRQS_ON_QUEUE_WITH_ERROR_ACTION_REQUEST });
export const hcCrqsOnQueueWithErrorSuccess = (payload) => ({ type: HELIX_CRQS_ACTIONS.HC_CRQS_ON_QUEUE_WITH_ERROR_ACTION_SUCCESS, payload });
export const hcCrqsOnQueueWithErrorFailure = (error)   => ({ type: HELIX_CRQS_ACTIONS.HC_CRQS_ON_QUEUE_WITH_ERROR_ACTION_FAILURE, error });

// Changes: Get CRQs to Close
export const hcGetCrqsToCloseRequest = ()        => ({ type: HELIX_CRQS_ACTIONS.HC_GET_CRQS_TO_CLOSE_REQUEST });
export const hcGetCrqsToCloseSuccess = (payload) => ({ type: HELIX_CRQS_ACTIONS.HC_GET_CRQS_TO_CLOSE_SUCCESS, payload });
export const hcGetCrqsToCloseFailure = (error)   => ({ type: HELIX_CRQS_ACTIONS.HC_GET_CRQS_TO_CLOSE_FAILURE, error });

// Changes: Get CRQs to Cancel
export const hcGetCrqsToCancelRequest = ()        => ({ type: HELIX_CRQS_ACTIONS.HC_GET_CRQS_TO_CANCEL_REQUEST });
export const hcGetCrqsToCancelSuccess = (payload) => ({ type: HELIX_CRQS_ACTIONS.HC_GET_CRQS_TO_CANCEL_SUCCESS, payload });
export const hcGetCrqsToCancelFailure = (error)   => ({ type: HELIX_CRQS_ACTIONS.HC_GET_CRQS_TO_CANCEL_FAILURE, error });

// Changes: Get CRQs to Approve
export const hcGetCrqsToApproveRequest = ()        => ({ type: HELIX_CRQS_ACTIONS.HC_GET_CRQS_TO_APPROVE_REQUEST });
export const hcGetCrqsToApproveSuccess = (payload) => ({ type: HELIX_CRQS_ACTIONS.HC_GET_CRQS_TO_APPROVE_SUCCESS, payload });
export const hcGetCrqsToApproveFailure = (error)   => ({ type: HELIX_CRQS_ACTIONS.HC_GET_CRQS_TO_APPROVE_FAILURE, error });

// Changes: Action
export const hcCrqsToChangeActionRequest = ()        => ({ type: HELIX_CRQS_ACTIONS.HC_CRQS_TO_CHANGE_ACTION_REQUEST });
export const hcCrqsToChangeActionSuccess = (payload) => ({ type: HELIX_CRQS_ACTIONS.HC_CRQS_TO_CHANGE_ACTION_SUCCESS, payload });
export const hcCrqsToChangeActionFailure = (error)   => ({ type: HELIX_CRQS_ACTIONS.HC_CRQS_TO_CHANGE_ACTION_FAILURE, error });

// Other: Get CRQs with Conflicts
export const hcGetCrqsWithConflictsRequest = ()        => ({ type: HELIX_CRQS_ACTIONS.HC_GET_CRQS_WITH_CONFLICTS_REQUEST });
export const hcGetCrqsWithConflictsSuccess = (payload) => ({ type: HELIX_CRQS_ACTIONS.HC_GET_CRQS_WITH_CONFLICTS_SUCCESS, payload });
export const hcGetCrqsWithConflictsFailure = (error)   => ({ type: HELIX_CRQS_ACTIONS.HC_GET_CRQS_WITH_CONFLICTS_FAILURE, error });

// Other: Get CRQs to Add Activity
export const hcGetCrqsToAddActivityRequest = ()        => ({ type: HELIX_CRQS_ACTIONS.HC_GET_CRQS_TO_ADD_ACTIVITY_REQUEST });
export const hcGetCrqsToAddActivitySuccess = (payload) => ({ type: HELIX_CRQS_ACTIONS.HC_GET_CRQS_TO_ADD_ACTIVITY_SUCCESS, payload });
export const hcGetCrqsToAddActivityFailure = (error)   => ({ type: HELIX_CRQS_ACTIONS.HC_GET_CRQS_TO_ADD_ACTIVITY_FAILURE, error });

// Other: CRQs with Conflicts Action
export const hcCrqsWithConflictsRequest = ()        => ({ type: HELIX_CRQS_ACTIONS.HC_CRQS_WITH_CONFLICTS_ACTION_REQUEST });
export const hcCrqsWithConflictsSuccess = (payload) => ({ type: HELIX_CRQS_ACTIONS.HC_CRQS_WITH_CONFLICTS_ACTION_SUCCESS, payload });
export const hcCrqsWithConflictsFailure = (error)   => ({ type: HELIX_CRQS_ACTIONS.HC_CRQS_WITH_CONFLICTS_ACTION_FAILURE, error });

// Other: CRQs to Add Activity Action
export const hcCrqsToAddActivityRequest = ()        => ({ type: HELIX_CRQS_ACTIONS.HC_CRQS_TO_ADD_ACTIVITY_ACTION_REQUEST });
export const hcCrqsToAddActivitySuccess = (payload) => ({ type: HELIX_CRQS_ACTIONS.HC_CRQS_TO_ADD_ACTIVITY_ACTION_SUCCESS, payload });
export const hcCrqsToAddActivityFailure = (error)   => ({ type: HELIX_CRQS_ACTIONS.HC_CRQS_TO_ADD_ACTIVITY_ACTION_FAILURE, error });

// Upload: Get Bot Summary
export const hcGetBotSummaryRequest = ()        => ({ type: HELIX_CRQS_ACTIONS.HC_GET_BOT_SUMMARY_REQUEST });
export const hcGetBotSummarySuccess = (payload) => ({ type: HELIX_CRQS_ACTIONS.HC_GET_BOT_SUMMARY_SUCCESS, payload });
export const hcGetBotSummaryFailure = (error)   => ({ type: HELIX_CRQS_ACTIONS.HC_GET_BOT_SUMMARY_FAILURE, error });

// Upload: Download Template
export const hcDownloadTemplateRequest = ()        => ({ type: HELIX_CRQS_ACTIONS.HC_DOWNLOAD_TEMPLATE_REQUEST });
export const hcDownloadTemplateSuccess = ()        => ({ type: HELIX_CRQS_ACTIONS.HC_DOWNLOAD_TEMPLATE_SUCCESS });
export const hcDownloadTemplateFailure = (error)   => ({ type: HELIX_CRQS_ACTIONS.HC_DOWNLOAD_TEMPLATE_FAILURE, error });

// Upload: Download Changes Template
export const hcDownloadChangesTemplateRequest = ()        => ({ type: HELIX_CRQS_ACTIONS.HC_DOWNLOAD_CHANGES_TEMPLATE_REQUEST });
export const hcDownloadChangesTemplateSuccess = ()        => ({ type: HELIX_CRQS_ACTIONS.HC_DOWNLOAD_CHANGES_TEMPLATE_SUCCESS });
export const hcDownloadChangesTemplateFailure = (error)   => ({ type: HELIX_CRQS_ACTIONS.HC_DOWNLOAD_CHANGES_TEMPLATE_FAILURE, error });

// Upload: Download Add Activity Template
export const hcDownloadAddActivityTemplateRequest = ()        => ({ type: HELIX_CRQS_ACTIONS.HC_DOWNLOAD_ADD_ACTIVITY_TEMPLATE_REQUEST });
export const hcDownloadAddActivityTemplateSuccess = ()        => ({ type: HELIX_CRQS_ACTIONS.HC_DOWNLOAD_ADD_ACTIVITY_TEMPLATE_SUCCESS });
export const hcDownloadAddActivityTemplateFailure = (error)   => ({ type: HELIX_CRQS_ACTIONS.HC_DOWNLOAD_ADD_ACTIVITY_TEMPLATE_FAILURE, error });

// Statistics: Get Statistics
export const hcGetStatisticsRequest = ()        => ({ type: HELIX_CRQS_ACTIONS.HC_GET_STATISTICS_REQUEST });
export const hcGetStatisticsSuccess = (payload) => ({ type: HELIX_CRQS_ACTIONS.HC_GET_STATISTICS_SUCCESS, payload });
export const hcGetStatisticsFailure = (error)   => ({ type: HELIX_CRQS_ACTIONS.HC_GET_STATISTICS_FAILURE, error });

// Creations: Export CRQs to Create
export const hcExportCrqsCreationsRequest = ()        => ({ type: HELIX_CRQS_ACTIONS.HC_EXPORT_CRQS_CREATIONS_REQUEST });
export const hcExportCrqsCreationsSuccess = ()        => ({ type: HELIX_CRQS_ACTIONS.HC_EXPORT_CRQS_CREATIONS_SUCCESS });
export const hcExportCrqsCreationsFailure = (error)   => ({ type: HELIX_CRQS_ACTIONS.HC_EXPORT_CRQS_CREATIONS_FAILURE, error });

// Changes: Export CRQs Changes
export const hcExportCrqsChangesRequest = ()        => ({ type: HELIX_CRQS_ACTIONS.HC_EXPORT_CRQS_CHANGES_REQUEST });
export const hcExportCrqsChangesSuccess = ()        => ({ type: HELIX_CRQS_ACTIONS.HC_EXPORT_CRQS_CHANGES_SUCCESS });
export const hcExportCrqsChangesFailure = (error)   => ({ type: HELIX_CRQS_ACTIONS.HC_EXPORT_CRQS_CHANGES_FAILURE, error });

// Other: Export CRQs Other
export const hcExportCrqsOtherRequest = ()        => ({ type: HELIX_CRQS_ACTIONS.HC_EXPORT_CRQS_OTHER_REQUEST });
export const hcExportCrqsOtherSuccess = ()        => ({ type: HELIX_CRQS_ACTIONS.HC_EXPORT_CRQS_OTHER_SUCCESS });
export const hcExportCrqsOtherFailure = (error)   => ({ type: HELIX_CRQS_ACTIONS.HC_EXPORT_CRQS_OTHER_FAILURE, error });

// Statistics: Export
export const hcExportCrqsStatisticsRequest = ()        => ({ type: HELIX_CRQS_ACTIONS.HC_EXPORT_CRQS_STATISTICS_REQUEST });
export const hcExportCrqsStatisticsSuccess = ()        => ({ type: HELIX_CRQS_ACTIONS.HC_EXPORT_CRQS_STATISTICS_SUCCESS });
export const hcExportCrqsStatisticsFailure = (error)   => ({ type: HELIX_CRQS_ACTIONS.HC_EXPORT_CRQS_STATISTICS_FAILURE, error });